import { render, staticRenderFns } from "./AForm.vue?vue&type=template&id=87682438&"
import script from "./AForm.vue?vue&type=script&lang=ts&"
export * from "./AForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports